module.exports = __webpack_public_path__ + "static/media/dadCo.122d8bab.jpg";